import { DateValue } from '@internationalized/date';
import { DatePickerCalendar, DatePickerStatic } from '@saas-ui/date-picker';

import { useFilterState } from '../../hooks/useFilterState';
import { FilterPopoverContent } from '../FilterPopoverButton';

const convertCalendarDate = (value: DateValue | null) => {
  return new Date(value!.year, value!.month - 1, value!.day, 23, 59, 59, 999);
};

type Props = {
  value: Date;
  onChange: (value: any) => void;
  onSubmit: () => void;
};

export const DateFilterPopoverContent = ({ value, onChange, onSubmit }: Props) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit,
  });

  const handleDateChange = (nextDate: DateValue | null) => {
    if (!nextDate) onChange(null);
    onChange(convertCalendarDate(nextDate));
    state.onChange(convertCalendarDate(nextDate));
  };

  return (
    <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
      <DatePickerStatic colorScheme="brand" granularity="day" onChange={handleDateChange}>
        <DatePickerCalendar
          w="full"
          sx={{
            table: { width: '100%' },
            svg: {
              height: 4,
              width: 4,
            },
          }}
        />
      </DatePickerStatic>
    </FilterPopoverContent>
  );
};
